<template>
  <div class="themeItem_scheduleDetail_baseInfor">
    <SCHEDULEDETAIL_BASEINFOR
      :CSMeetScheduleInfo="currMatchDetailInfor"
    ></SCHEDULEDETAIL_BASEINFOR>
  </div>
</template>
<script>
// 分享之后显示，不需要分享按钮
import cup_base_data_mixin from '@mixins/cup_base_data'
import SCHEDULEDETAIL_BASEINFOR from '@components/platfromBase/compreSportsMeet/scheduleDetail_baseInfor.vue'
export default {
  name: 'themeItem_scheduleDetail_baseInfor',
  mixins: [cup_base_data_mixin],
  components: { SCHEDULEDETAIL_BASEINFOR },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    currSportsDetail: {
      type: Object,
      default: () => {
        // BDM_TAU: 汤尤杯
        return { sportsId: 'BDM_TAU' }
      },
    },
  },
  data() {
    return {
      sportsTypeArr: ['combat', 'uncombat'],
      // formatSportsIdArr 和 [complex_resultTypeArr|complex_matchStatusColorArr] 的索引是对应
      formatSportsIdArr: ['BDM_TAU'],
      complex_resultTypeArr: [
        [
          {
            name: '中间成绩',
            key: 'INTERMEDIATE',
            className: '',
          },
          {
            name: '实时',
            key: 'LIVE',
            className: '',
          },
          {
            name: '官方',
            key: 'OFFICIAL',
            className: '',
          },
          {
            name: '部分成绩',
            key: 'PARTIAL',
            className: '',
          },
          {
            name: '仲裁中',
            key: 'PROTESTED',
            className: '',
          },
          {
            name: '秩序单',
            key: 'START_LIST',
            className: '',
          },
          {
            name: '未确认',
            key: 'UNCONFIRMED',
            className: '',
          },
          {
            name: '非官方',
            key: 'UNOFFICIAL',
            className: '',
          },
        ],
      ],
      complex_matchStatusColorArr: [
        [
          {
            colorClass: 'unstart',
            key: ['GETTING_READY', 'SCHEDULED'],
            name: ['已就绪', '按日程计划'],
          },
          {
            colorClass: 'playing',
            key: ['RUNNING', 'SCHEDULED_BREAK'],
            name: ['比赛中', '中场休息'],
          },
          {
            colorClass: 'finished',
            key: ['FINISHED', 'UNSCHEDULED'],
            name: ['已结束', '未安排'],
          },
          {
            colorClass: 'other',
            key: ['CANCELLED', 'DELAYED', 'INTERRUPTED', 'RESCHEDULED'],
            name: ['已取消', '延误', '中断', '推迟', '改期'],
          },
        ],
      ],
      resultTypeArr: null,
      matchStatusColorArr: null,
    }
  },
  computed: {
    currMatchDetailInfor() {
      let currResultType = null
      let CSMeetScheduleInfo = null

      if (this.CSMeetMatchDetailInforFormat) {
        CSMeetScheduleInfo = this.CSMeetMatchDetailInforFormat(
          this.datas.data.dataList[0]
        )
      }
      if (this.resultTypeArr && CSMeetScheduleInfo) {
        this.resultTypeArr.forEach((typeItem) => {
          if (typeItem.key === CSMeetScheduleInfo.result_status) {
            currResultType = typeItem
          }
        })
      }
      const item = JSON.parse(JSON.stringify(CSMeetScheduleInfo))
      let newItem = {}
      console.debug('this.currMatchDetailInfor:', newItem)
      if (item.scheduleCode) {
        newItem.matchTime = item.formatTime
        newItem.matchName = `${item.disciplineName}·${item.scheduleName}`
        newItem.isChina = item.cn
        newItem.isGold = item.medalFlag === '1'
        newItem.type = item.confrontation
          ? this.sportsTypeArr[0]
          : this.sportsTypeArr[1]
        newItem.matchId = item.scheduleCode
        newItem.venueName = item.venueName
        this.matchStatusColorArr.forEach((statusItem, statusIndex) => {
          let indexNo = statusItem.key.indexOf(
            CSMeetScheduleInfo.scheduleStatus
          )
          if (indexNo > -1) {
            newItem.matchStatus = statusItem.name[indexNo]
          }
          if (indexNo > -1 && statusIndex === 0) {
            //比赛未开始；显示比赛日期和时间
            currResultType = {
              name: `${item.formatDate} ${item.formatTime}`,
              key: 'MATCHDATE',
              className: 'matchDate',
            }
          }
        })
        newItem.irm1Result = item.irm1Result
        newItem.irm2Result = item.irm2Result
        newItem.sportsId = item.disciplineCode
        newItem.sportsName = item.disciplineName
        newItem.eventId = item.eventCode
        newItem.eventName = item.eventName
        newItem.scheduleName = item.scheduleName
        newItem.formatDate = item.formatDate
        newItem.formatTime = item.formatTime
        newItem.competitor1Names = item.competitor1Names
          ? item.competitor1Names.map((ceil) => {
              return {
                playerName: ceil.athleteName,
                playerLogo: ceil.athleteLogo,
              }
            })
          : []
        newItem.competitor2Names = item.competitor2Names
          ? item.competitor2Names.map((ceil) => {
              return {
                playerName: ceil.athleteName,
                playerLogo: ceil.athleteLogo,
              }
            })
          : []
        newItem.competitorType = item.competitorType
        newItem.medalist = item.medals
          ? item.medals.map((player, index) => {
              return {
                playerId: index + 1,
                playerName: player.competitorName,
                medalType: player.medalType,
                delegationName: player.organisationName,
                delegationLogo: player.organisationLogo,
              }
            })
          : []

        if (newItem.type === this.sportsTypeArr[0]) {
          let homeName = '',
            awayName = ''
          if (item.competitorType === 'T') {
            homeName = item.organisation1Name
            awayName = item.organisation2Name
          }
          newItem.homeName = homeName
          newItem.awayName = awayName

          newItem.homeScore = item.competitor1Result
          newItem.awayScore = item.competitor2Result
        }
        newItem.homeLogo = item.organisation1Logo
        newItem.awayLogo = item.organisation2Logo
        newItem.annotation = item.annotation ? item.annotation : []
        newItem.currResultType = currResultType
        console.debug('this.currMatchDetailInfor:', newItem)
      } else {
      }
      return newItem
      // return {
      //   matchTime: null,
      //   matchName: 'null·汤姆斯杯小组赛A组',
      //   isChina: false,
      //   isGold: false,
      //   type: 'combat',
      //   matchId: '100373',
      //   venueName: 'Impact Arena',
      //   matchStatus: '已结束',
      //   irm1Result: null,
      //   irm2Result: null,
      //   sportsId: null,
      //   sportsName: null,
      //   eventId: null,
      //   scheduleName: '汤姆斯杯小组赛A组',
      //   formatDate: null,
      //   formatTime: null,
      //   competitor1Names: [],
      //   competitor2Names: [],
      //   competitorType: 'T',
      //   medalist: [],
      //   homeName: '印度尼西亚',
      //   awayName: '新加坡',
      //   homeScore: '4',
      //   awayScore: '1',
      //   homeLogo:
      //     'https://hyper-sports-res.mixtmt.com/badminton/season/5032022/team/1016.png',
      //   awayLogo:
      //     'https://hyper-sports-res.mixtmt.com/badminton/season/5032022/team/1029.png',
      //   currResultType,
      //   annotation: [],
      // }
    },
  },
  methods: {
    CSMeetMatchDetailInforFormat(resData) {
      if (this.formatSportsIdArr.includes(this.currSportsDetail.sportsId)) {
        let index = this.formatSportsIdArr.indexOf(
          this.currSportsDetail.sportsId
        )
        this.resultTypeArr = this.complex_resultTypeArr[index]
        this.matchStatusColorArr = this.complex_matchStatusColorArr[index]
        if (this.currSportsDetail.sportsId.indexOf('_') > -1) {
          resData.disciplineCode = this.currSportsDetail.sportsId.split('_')[0]
        } else {
          resData.disciplineCode = this.currSportsDetail.sportsId // 'BDM'
        }
        resData.scheduleStatus = this.formatMatchStatus(
          resData.scheduleStatus - 0
        )
      }
      return resData
    },
    formatMatchStatus(matchStatus) {
      let str = ''
      const num = Number(matchStatus)
      if (this.formatSportsIdArr.includes(this.currSportsDetail.sportsId)) {
        if (num === 1) {
          str = 'SCHEDULED'
        } else if (num === 2) {
          str = 'RUNNING'
        } else if (num === 3) {
          str = 'CANCELLED'
        } else if (num === 4) {
          str = 'FINISHED'
        } else {
        }
      }

      return str
    },
  },
}
</script>
<style lang="scss" scoped>
.themeItem_scheduleDetail_baseInfor {
  width: 100%;
  padding-bottom: 1.1vw;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
}
</style>
